export default {
	create (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'staff_work_schedule/create', params)
	},
	update (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'staff_work_schedule/update', params)
	},
	delete (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'staff_work_schedule/delete', params)
	},
	all (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'staff_work_schedule/all', params)
	},
	one (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'staff_work_schedule/one', params)
	}
}



// WEBPACK FOOTER //
// ./src/api/StaffWorkSchedule.js